import { render, staticRenderFns } from "./500.vue?vue&type=template&id=9248ea2c&scoped=true"
import script from "./500.vue?vue&type=script&lang=js"
export * from "./500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9248ea2c",
  null
  
)

export default component.exports